import { gridGutter1q4, gridGutterHalf, gridGutter, fontSize18 } from '@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout'
import { grayBorder } from '@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors'
import { flexWrapper } from '../style'

export const deleteItem = `
  cursor: pointer;
  margin: ${gridGutterHalf}px 0 0 0;
`

export const blockDeletion = `
  color: ${grayBorder};
  cursor: not-allowed;
  margin-top: ${gridGutterHalf}px;
  display: inline-block;
`

export const flex = `
  ${flexWrapper};

   .flatpickr-wrapper + i {
      font-weight: 500;
      font-size: ${fontSize18};
    }

  .flex-item {
    flex: 1;
  
    > div {
      margin: 0 ${gridGutter1q4}px 0 0;
    }
  
    + .flex-item {
      > div {
        margin: 0 0 0 ${gridGutter1q4}px;    
      }
    }
  
    @media screen and (max-width: 991px) {    
      margin-bottom: ${gridGutterHalf}px;
    }
  }
`

export const ruler = `
  border-top: 1px solid ${grayBorder};
  border-bottom: 1px solid transparent;
  margin-top: ${gridGutter}px;
  padding-top: ${gridGutterHalf}px;
`